<template>
	<div class="input-wrapper">
		<label :for="name">
			<div class="heading-5" :style="{ color: labelColor }">
				{{ `${label} ` }}
				<span>{{ ` ${required ? ' *' : ''}` }}</span>
			</div>
		</label>

		<div class="input-container">
			<input
				:id="name"
				ref="inputToCopy"
				type="text"
				:class="size"
				:value="localValue"
				:name="name"
				readonly
			/>
			<button class="copy-btn" :title="$t('copy')" @click="copyToClipboard">
				<svgicon name="icon-copy"></svgicon>
			</button>
		</div>
	</div>
</template>
<script>
import '@/components/icons/icon-copy';
export default {
	props: {
		label: {
			type: String,
			default: ''
		},
		labelColor: {
			type: String,
			default: '#687682'
		},
		value: {
			type: [String, Number],
			default: ''
		},
		name: {
			type: String,
			required: true
		},
		size: {
			type: String,
			default: 'large',
			validator: value => ['large', 'mid', 'small'].includes(value)
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			localValue: this.value
		};
	},
	watch: {
		value(newValue) {
			this.localValue = newValue;
		}
	},
	methods: {
		copyToClipboard() {
			navigator.clipboard.writeText(this.localValue);
		}
	}
};
</script>
<style lang="scss" scoped>
.input-wrapper {
	position: relative;
	width: 100%;
}

.input-container {
	position: relative;
	display: flex;
	align-items: center;
}

label .heading-5 {
	margin-bottom: 4px;
	span {
		color: $requiredFieldAsterisk;
	}
}

input {
	background-color: $input-bgcolor;
	border: 1px solid $container-border;
	border-radius: 4px;
	outline: 0;
	color: $input-color;
	font-family: 'RobotoRegular';
	font-size: 18px;
	line-height: 27px;
	width: 100%;
	padding-right: 40px;
	cursor: auto;

	&.large {
		height: 48px;
		text-indent: 16px;
	}
	&.mid {
		height: 48px;
		text-indent: 16px;
	}
	&.small {
		height: 32px;
		text-indent: 8px;
	}
}

.copy-btn {
	position: absolute;
	right: 8px;
	height: 32px;
	width: 32px;
	background-color: transparent;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;

	&:hover {
		svg {
			fill: $hover-state;
		}
	}
	svg {
		width: 20px;
		height: 20px;
		fill: $primary-state;
	}
}
</style>
